import  { USER_CHANGE,
          USER_LOGGEDIN,
          USER_LOGGEDOUT,
          USER_LOADING,
          USER_AUTH_ERROR } from '../actions/actionTypes'

const inicialState = {
    name: '',
    email: '',
    userId: '',
    password: '',
    passwordConfirm: '',
    tokenAuth: '',
    loading: '',
    authError:'',
    actionUser: '',
    admin: false
}

const reducer = (state=inicialState, action) => {
    switch (action.type){
        case USER_CHANGE:{
            const newState = {...state}
            newState[action.payload.event.target.name]= action.payload.event.target.value
            newState.authError=''
            return {...newState}
        }
        case USER_AUTH_ERROR:{
            return{
                ...state,
                authError: action.payload.error
            }
        }
        case USER_LOADING:{
            return{
                ...state,
                loading: !state.loading
            }
        }
        case USER_LOGGEDIN: {
            return{
                ...action.payload.user
            }
        }
        case USER_LOGGEDOUT: {
            return{
                ...inicialState,
                email: action.payload.user ? action.payload.user.email : ''
            }
        }
        default:{
            return {...state}
            }

        }
    }

export default reducer